import React from 'react';
import { FiFileText, FiMapPin } from 'react-icons/fi';
import { usePlaceVisits } from '../../hooks/usePlaceVisits';

export default function PlaceVisitHistory({ placeId }: { placeId: string }) {
  const { groups, loading, error, retry } = usePlaceVisits(placeId);
  const days = Array.from(new Set(groups.flatMap(group => group.visits.map(visit => visit.date)))).sort().reverse();
  const link = (id: string, view: string) => `/records/?${new URLSearchParams({ broadcast: id, view, place: placeId })}`;
  return <section className="place-history" aria-label="訪問履歴">
    <h3>訪問履歴</h3>
    {loading && <p className="place-history__status" role="status">訪問履歴を読み込み中です。</p>}
    {error ? <div className="place-history__error" role="alert"><p>{error}</p><button type="button" onClick={retry}>再試行</button></div>
      : <>{!loading && !days.length && <p>この場所の配信記録はまだありません。</p>}
        {days.map(day => <section className="place-history__day" key={day}>
          <h4>{day.split('-').map(Number).join('/')}</h4>
          {groups.filter(group => group.visits.some(visit => visit.date === day)).sort((a, b) => b.sortTime - a.sortTime || b.id.localeCompare(a.id)).map(group =>
            <article className="place-history__broadcast" key={group.id}>
              <a className="place-history__title" href={link(group.id, 'log')}><FiFileText aria-hidden="true" />{group.title}</a>
              <div className="place-history__links"><a href={link(group.id, 'route')}><FiMapPin aria-hidden="true" />訪問順を見る</a>
                <a href={link(group.id, 'log')}><FiFileText aria-hidden="true" />ログを読む</a></div>
              {group.unknownTime && <p className="place-history__note">開始時刻が未記録のため、日付は配信日（日本時間）です。</p>}
              {group.approximate && <p className="place-history__note">配信開始時刻が概算のため、時刻も目安です。</p>}
              <ol>{group.visits.filter(visit => visit.date === day).map(visit => <li key={visit.id}>
                <p className="place-history__time">{visit.time}{!group.unknownTime && <small>（{group.zone}）</small>}</p>
                <p className="place-history__summary">{visit.summary}</p>
                {visit.inferred && <p className="place-history__note">周辺情報などから推定した地点です。</p>}
              </li>)}</ol>

            </article>)}
        </section>)}</>}
  </section>;
}
